import React, { useState, useEffect } from 'react'
import { Form, InputPicker } from 'rsuite';
import { Button, Card, Row, Col, Table, CardGroup } from 'react-bootstrap'
import * as dayjs from 'dayjs';
import { FaCheck, FaQuestion, FaTimes } from 'react-icons/fa';
import Swal from 'sweetalert2'
import DocumentUpload from '../../../Shared/Upload/DocumentUpload';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import boardMemberService from '../../../../services/Public/boardMember.service';
import AddBoardMemberCommentModal from '../../../Shared/Modal/AddBoardMemberCommentModal';
import boardCommentsService from '../../../../services/Shared/boardComments.service';
import LoadingSpinner from '../../../Shared/GenericComponents/LoadingSpinner';
import BoardAttachmentGrid from '../../../Shared/Grid/BoardAttachmentGrid';
import { AccessibleSelectPicker } from '../../../Shared/GenericComponents/AccessibleComponents';

function BoardApproval() {
    const [hasLoaded, setHasLoaded] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [parentId, setParentId] = useState();
    const [modalData, setModalData] = useState({});
    const [assignedBoardMembers, setAssignedBoardMemebers] = useState([]);
    const selector = useSelector(x => x);
    const decisionData = [
        { "label": "Approved", "value": { id: 1, boardMemberDecision: "Approved" } },
        { "label": "Declined", "value": { id: 2, boardMemberDecision: "Declined" } }];
    const [boardApproval, setBoardApproval] = useState({});
    const getDecisionValue = (decision) => {
        const result = decisionData.find(item => item.label === decision);
        return result ? result.value : null;
    };
    const currentBoardMemberResponseId = selector.currentBoardMemberResponseId;
    const currentParentTypeId = selector.currentBoardParentTypeId;
    const entityId = selector.userInfo.EntityId;
    const attachmentParentTypeId = currentParentTypeId == 1 ? 7 : 8;
    // There are currently only 2 parent types from the view 1-App 2-Reinstatement, and we need to map this to Attachment.CodeParentType which is 7 -App Board Member Response and 8- Reinstatement Board Member Response
    useEffect(() => {
        boardMemberService.getBoardMemberResponse(currentBoardMemberResponseId, currentParentTypeId).then((response) => {
            boardCommentsService.getBoardComments(response.data.parentId, currentParentTypeId).then((comments) => {
                boardMemberService.getAssignedBoardMembers(response.data.parentId, currentParentTypeId).then((boardMembers) => {
                    setParentId(response.data.parentId)
                    setBoardApproval({
                        ...response.data,
                        boardDecision: getDecisionValue(response.data.boardMemberDecision),
                        dateReceived: response.data.dateReceived != null ? dayjs(response.data.dateReceived).format('YYYY-MM-DD') : null,
                        dateSent: response.data.dateCrte != null ? dayjs(response.data.dateCrte).format('YYYY-MM-DD') : null,
                        comments: comments.data
                    });
                    setAssignedBoardMemebers(boardMembers.data)
                    setHasLoaded(true);
                })
            });
        });
    }, [])
    const saveBoardApproval = () => {
        let dataToTransmit = {
            boardMemberResponseId: boardApproval.boardMemberResponseId,
            parentId: parentId,
            parentTypeId: boardApproval.parentTypeId,
            boardMemberDecisionId: boardApproval.boardDecision?.id
        };
        boardMemberService.saveBoardMemberResponse(dataToTransmit).then((success) => {
            if (success) {
                Swal.fire("Saved", "Board Response Saved!", "success");
                Swal.fire({
                    title: "Saved",
                    text: "Board Response Saved!",
                    icon: "success",
                    allowOutsideClick: false,
                    closeOnConfirm: false
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.href = "/individual/boardApprovals";
                    }
                });
            }
            else {
                Swal.fire("Failed to save response.");
            }
        });
    };
    const refreshComments = async (id) => {
        const comments = await boardCommentsService.getBoardComments(parentId, currentParentTypeId);
        setBoardApproval({ ...boardApproval, comments: comments.data })
    }
    const openCommentModal = () => {
        setModalData({
            parentId: parentId,
            boardMemberResponseId: currentBoardMemberResponseId,
            parentTypeId: currentParentTypeId,
            comment: ''
        });
        setShowModal(true);
    }
    return <>
        {hasLoaded ? <>
            <AddBoardMemberCommentModal
                modalData={modalData}
                show={showModal}
                onHide={() => setShowModal(false)}
                refreshComments={refreshComments}
            />
            <Form formValue={boardApproval} onChange={setBoardApproval}>
                <Card>
                    <Card.Header>
                        <h4>{boardApproval.boardAssignmentType} - {boardApproval.entityName}</h4>
                    </Card.Header>
                    <Card.Body>
                        {assignedBoardMembers.length > 0 &&
                            <>
                                <h4><center>Assigned Board Members</center></h4>
                                <CardGroup>
                                    <Row className='w-100'>
                                        {assignedBoardMembers.map((val) => <>
                                            <Col>
                                                <Card className="mx-1 p-0 mb-3">
                                                    <Card.Header style={val.item2 == "Approved" ? { backgroundColor: 'lightGreen' } : val.item2 == "Declined" ? { backgroundColor: 'rgba(220, 20, 60, 0.5)' } : { backgroundColor: '#FAFAD2' }}>
                                                        <div className='w-100 d-flex flex-column'>
                                                            <div className="d-flex justify-content-between align-items-center flex-nowrap text-nowrap">
                                                                <b className="me-2">{val.item1}</b>
                                                                {val.item2 &&
                                                                    <>
                                                                        {
                                                                            val.item2 == "Approved" &&
                                                                            <FaCheck className="flex-shrink-0" style={{ color: 'green', fontSize: '24' }} />
                                                                        }
                                                                        {val.item2 == "Declined" &&
                                                                            <FaTimes className="flex-shrink-0" style={{ color: '#EB0000', fontSize: '24' }} />
                                                                        }
                                                                        {val.item2 == "Pending" &&
                                                                            <FaQuestion className="flex-shrink-0" style={{ color: 'gold', fontSize: '24' }} />
                                                                        }
                                                                    </>
                                                                }
                                                            </div>
                                                        </div>
                                                    </Card.Header>
                                                </Card></Col ></>)}
                                    </Row>
                                </CardGroup>
                            </>
                        }
                        <hr />
                        <Row style={{ marginTop: '.5em' }}>
                            <Col>
                                <Form.Group>
                                    <Form.ControlLabel>
                                        <strong>
                                            Date Sent
                                        </strong>
                                    </Form.ControlLabel>
                                    <Form.Control readOnly type="date" name="dateSent" block />
                                    <Form.HelpText className="d-none">Date Sent</Form.HelpText>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.ControlLabel>
                                        <strong>
                                            Decision Date
                                        </strong>
                                    </Form.ControlLabel>
                                    <Form.Control readOnly type="date" name="dateReceived" block />
                                    <Form.HelpText className="d-none">Decision Date</Form.HelpText>
                                </Form.Group>
                            </Col>
                        </Row>
                        <br />
                        <BoardAttachmentGrid
                            attachmentParentTypeId={attachmentParentTypeId}
                            parentId={boardApproval.parentId}
                            parentTypeId={boardApproval.parentTypeId}
                            entityId={entityId}
                            credentialOrAppTypeId={boardApproval.appReinstatementTypeId}
                            isApp={boardApproval.parentTypeId == 1}
                            attachmentSectionId={boardApproval.attachmentSectionId}
                        />

                        <hr />
                        <Row className="mb-2">
                            <Col>
                                <h4>Comments</h4>
                            </Col>
                            <Col style={{ textAlign: 'right' }}>
                                <Button variant="primary" title="Add Comment" onClick={openCommentModal}>Add Comment</Button>
                            </Col>
                        </Row>
                        <br />
                        <Table hover className={"table-bordered"}>
                            <thead>
                                <tr>
                                    <th>Comment</th>
                                    <th>From</th>
                                    <th>Date/Time</th>

                                </tr>
                            </thead>
                            <tbody>
                                {boardApproval.comments.length ? boardApproval.comments.map((item, i) => {
                                    return (
                                        <tr key={item.id} id={i}>
                                            <td>{item.comment}</td>
                                            <td>{item.userName}</td>
                                            <td>{`${new Date(item.dateCrte).toLocaleDateString()} ${new Date(item.dateCrte).toLocaleTimeString()}`}</td>
                                        </tr>
                                    )
                                }) :
                                    <tr>
                                        <td style={{ textAlign: 'center' }} colSpan={3}><h5>No Comments</h5></td>
                                    </tr>
                                }
                            </tbody>
                        </Table>
                        <Row className="mt-3">
                            <Col>
                                <Form.Group>
                                    <Form.ControlLabel><strong>Decision</strong></Form.ControlLabel>
                                    <Form.Control
                                        block
                                        name="boardDecision"
                                        placeholder=""
                                        accepter={AccessibleSelectPicker}
                                        data={decisionData} />
                                    <Form.HelpText className="d-none">Decision</Form.HelpText>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="text-center mt-3">
                                <Button name="saveButton" variant="primary" className="ms-2" onClick={saveBoardApproval}>Save</Button>
                                <Button name="backToQueue" as={Link} to="/individual/boardApprovals" variant="primary" className="ms-2" >Back to Queue</Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Form>
        </> : <LoadingSpinner />
        }
    </>;
}

export default BoardApproval;